import React from "react";
import { Form, Checkbox, Select, Row, Col } from "antd";
import { counties as countiesRaw } from "../masterLists";

const industriesList = [
  "Automotive",
  "Business Services / Consulting",
  "Childcare / Elder Care / Social Services",
  "Construction",
  "Education",
  "Entertainment",
  "Energy / Utilities",
  "Financial Services (personal & business loans)",
  "Food & Beverage",
  "Government & Public Sector",
  "Healthcare",
  "Health & Wellness (fitness, nutrition, lifestyle)",
  "Home Improvement",
  "Tourism & Hospitality",
  "Insurance",
  "Legal Services",
  "Manufacturing",
  "Marketing / Advertising / Media",
  "Nonprofits & Community Organizations",
  "Political / Advocacy",
  "Professional Services (accounting, HR, IT, etc.)",
  "Real Estate & Housing",
  "Restaurants",
  "Retail & Ecommerce",
  "Supermarkets / Grocery",
  "Technology / Software / IT",
  "Telecommunications",
  "Transportation / Logistics",
];

const sorted = (a, b) => a.localeCompare(b, undefined, { sensitivity: "base" });

const renderCheckboxGrid = (options = [], selectedValues, key, setFormValues) => {
  const items = [...options].sort(sorted);

  const half = Math.ceil(items.length / 2);
  const left = items.slice(0, half);
  const right = items.slice(half);

  return (
    <Checkbox.Group
      value={selectedValues || []}
      onChange={(checked) => setFormValues((prev) => ({ ...prev, [key]: checked }))}
      style={{ width: "100%" }}
    >
      <Row gutter={[24, 8]}>
        <Col xs={24} md={12}>
          {left.map((label) => (
            <div key={label} style={{ marginBottom: 8 }}>
              <Checkbox value={label}>{label}</Checkbox>
            </div>
          ))}
        </Col>
        <Col xs={24} md={12}>
          {right.map((label) => (
            <div key={label} style={{ marginBottom: 8 }}>
              <Checkbox value={label}>{label}</Checkbox>
            </div>
          ))}
        </Col>
      </Row>
    </Checkbox.Group>
  );
};

const Section2 = ({ formValues, setFormValues }) => {
  const counties = Array.isArray(countiesRaw) ? countiesRaw : [];

  return (
    <Form layout="vertical">
      {/* Q7 – Industry */}
      <Form.Item label="7. What industry does your business operate in? (Select all that apply)">
        {renderCheckboxGrid(industriesList, formValues.industries, "industries", setFormValues)}
      </Form.Item>

      {/* Q8 – Entity Type */}
      <Form.Item label="8. What is your business entity type?">
        <Select
          placeholder="Select entity type"
          value={formValues.entityType}
          onChange={(val) => setFormValues({ ...formValues, entityType: val })}
        >
          <Select.Option value="Sole Proprietor">
            Sole Proprietor (must have $200k+ annual revenue)
          </Select.Option>
          <Select.Option value="LLC">Limited Liability Company (LLC)</Select.Option>
          <Select.Option value="Corporation">Corporation (C or S)</Select.Option>
          <Select.Option value="Nonprofit">Nonprofit</Select.Option>
          <Select.Option value="Government">Government / Public Agency</Select.Option>
          <Select.Option value="Political">Political Organization</Select.Option>
        </Select>
      </Form.Item>

      {/* Q9 – Counties */}
      <Form.Item label="9. In which Connecticut counties do you currently provide services, accept clients, or offer coverage?">
        {renderCheckboxGrid(counties, formValues.counties, "counties", setFormValues)}
      </Form.Item>
    </Form>
  );
};

export default Section2;
